import { render, staticRenderFns } from "./forgetForm.vue?vue&type=template&id=ca25a7ee&scoped=true&"
import script from "./forgetForm.vue?vue&type=script&lang=js&"
export * from "./forgetForm.vue?vue&type=script&lang=js&"
import style0 from "./forgetForm.vue?vue&type=style&index=0&id=ca25a7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca25a7ee",
  null
  
)

export default component.exports